import { createContext } from 'react';

export type ReferralCode = {
  code: string;
  referralCreditAmount: number | null;
  isValid: boolean;
};

export type Context = {
  referralCode: ReferralCode | null;
  setReferralCode: (code: ReferralCode | null) => void;
};

export const CompleteBookingContext = createContext<Context | undefined>(
  undefined,
);
